import { Fragment } from "react";
import { createRoot } from "react-dom/client";
// import './index.css';
import "./globals.css";
import "./assets/css/swiper.min.css";

import App from "./App";
import Services from "./components/common/AlertService";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Fragment>
    <Services>
      <App />
    </Services>
  </Fragment>
);
